import { IStorytellingModule } from '@models/IStorytellingModule';
import SiteEnum from '@models/enums/SiteEnum';
import SharedStorytellingModule from '@organisms/StorytellingModule/StorytellingModule';

const StorytellingModule = (props: IStorytellingModule) => (
  <div className="tw-component-margin tw-mt-16 md:tw-mt-20">
    <SharedStorytellingModule
      {...props}
      wrapperClasses="b2b-container"
      site={SiteEnum.B2B}
    />
  </div>
);

export default StorytellingModule;
